import { render, staticRenderFns } from "./RiskLevelModal.vue?vue&type=template&id=340f716e&scoped=true&"
import script from "./RiskLevelModal.vue?vue&type=script&lang=ts&"
export * from "./RiskLevelModal.vue?vue&type=script&lang=ts&"
import style0 from "./RiskLevelModal.vue?vue&type=style&index=0&id=340f716e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340f716e",
  null
  
)

export default component.exports